/*
    Copyright (C) 2017 Red Hat, Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

            http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
import { FunctionComponent, ReactElement, useEffect, useState } from 'react';

export interface IDelayedBooleanProps {
  value: boolean;
  delay?: number;
  children: (value: boolean) => ReactElement | null;
}

export const DelayedBoolean: FunctionComponent<IDelayedBooleanProps> = ({
  value,
  delay = 1000,
  children,
}) => {
  const [delayedValue, setDelayedValue] = useState(value);
  useEffect(() => {
    const updateValue = () => setDelayedValue(value);
    const timer = setTimeout(updateValue, delay);
    return () => clearTimeout(timer);
  }, [delay, value]);
  return children(delayedValue);
};
